import { render, staticRenderFns } from "./SubscriptionForm.vue?vue&type=template&id=3fb8c80b"
import script from "./SubscriptionForm.vue?vue&type=script&lang=js"
export * from "./SubscriptionForm.vue?vue&type=script&lang=js"
import style0 from "./SubscriptionForm.vue?vue&type=style&index=0&id=3fb8c80b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports